import React,{useState} from 'react'
import { WarrantyPageStyle } from './Warranty.styled'
import TopBar from '../../components/TopBar/TopBar'
import { HeadingStyle } from '../../styles/HeadingStyles'
import Footer from '../../components/footer/Footer'
import { ExportDataStyle } from '../../components/Export/ExportData.style'
import { getAllBaseStationWarranty, getBaseStationWarranty, getResellerWarranty } from '../../api/WarrantyApi'
import { useDB } from '../../context/DynamoDBContext'
import { useQuery,useQueryClient } from '@tanstack/react-query'
import { MainBodyStyle } from '../../styles/MainBodyStyles'

const ResellerTable=({data,status})=>{
    return <WarrantyPageStyle>
        <div className='table-main'>
            <div className='table-container3'>
                <div className='table-div2'>
                    <table className="table table-hover">
                        <thead className='table-head'>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Device MAC</th>
                                <th scope="col">Warranty Start Date</th>
                                <th scope="col">Warranty End Date</th>
                                <th scope="col">Warranty Days Remaining</th>
                                <th scope="col">Warranty Current Status</th>
                                <th scope="col">Reseller ID</th>
                            </tr>
                            </thead>
                        <tbody>
                            {status? (
                                <tr>
                                    <td colSpan={7}><p className='table-loading'>Loading...</p></td>
                                </tr>)
                                :
                                (
                                    data.length === 0 ?(
                                        <tr>
                                            <td colSpan={7}><p className='table-loading'>No Data Available</p></td>
                                        </tr>
                                    )
                                    :
                                    data.map((item,index)=>{
                                        return <tr key={index}>
                                            <th scope="row">{index+1}</th>
                                            <td>{item.BeaconMAC!==""?item.BeaconMAC:item.GatewayMAC}</td>
                                            <td>
                                                {item?.start}
                                            </td>
                                            <td>
                                                {item?.end} 
                                                    
                                            </td>
                                            <td>
                                                {item?.remain} 
                                                    
                                            </td>
                                            <td>
                                                {item?.status} 
                                                    
                                            </td>
                                            <td>
                                                {item.ResellerID} 
                                                    
                                            </td>
                                            
                                        </tr>
                                    })
                                )
                            }
                                        
                                        
                                        
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </WarrantyPageStyle>
}

const BaseStationTable=({data,status})=>{
    return <WarrantyPageStyle>
        <div className='table-main'>
            <div className='table-container3'>
                <div className='table-div2'>
                    <table className="table table-hover">
                        <thead className='table-head'>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">GatewayMAC</th>
                                <th scope="col">Email</th>
                                <th scope="col">Firmware</th>
                                <th scope="col">Warranty Start Date</th>
                                <th scope="col">Warranty End Date</th>
                                <th scope="col">Warranty Days Remaining</th>
                            </tr>
                            </thead>
                        <tbody>
                            {status? (
                                <tr>
                                    <td colSpan={7}><p className='table-loading'>Loading...</p></td>
                                </tr>)
                                :
                                (
                                    data.length === 0 ?(
                                        <tr>
                                            <td colSpan={7}><p className='table-loading'>No Data Available</p></td>
                                        </tr>
                                    )
                                    :
                                    data.map((item,index)=>{
                                        return <tr key={index}>
                                            <th scope="row">{index+1}</th>
                                            <td>{item.GatewayMAC}</td>
                                            <td>{item.Email}</td>
                                            <td>{item.Firmware}</td>
                                            <td>
                                                {item?.start}
                                            </td>
                                            <td>
                                                {item?.end} 
                                                    
                                            </td>
                                            <td>
                                                {item?.remain} 
                                                    
                                            </td>
                                        </tr>
                                    })
                                )
                            }
                                        
                                        
                                        
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </WarrantyPageStyle>
}

const Warranty = () => {
    const {dynamoDBClient}=useDB()
    const queryClient = useQueryClient();
    const [searchData, setSearchData] = useState("")
    const [enableSearch, setEnableSearch] = useState(false)
    const [searchFilter, setSearchFilter] = useState(1)
    const [loading, setLoading] = useState(false)
    const [reportBtnEnable, setReportBtnEnable] = useState(true)
    const [resellerData, setResellerData] = useState([])
    const [baseStationData, setBaseStationData] = useState([])
    const [error, setError] = useState("")
    const data=[
        {id:"JUE78JHFER54",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:""},
        {id:"HFU9IKEHYSB4",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:""},
        {id:"LDKI398HNE3V",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"Test1"},
        {id:"BH0037YDHJJS",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:""},
        {id:"EH00584EHNBS",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"Ocufii"},
        {id:"JEI8UYGF54SE",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
        {id:"K1KI7GFVX4O9",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
        {id:"NK2WQ268GESZ",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
        {id:"NHD5JU87FES4",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
        {id:"NKP0FS2ZCVFT",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
        {id:"NB654DVH9UZH",start:"20-03-23",end:"10-07-2024",remain:"3 Days",status:"In Warranty",reseller:"John"},
    ]

    const {
        status:rStatus,
        data:rData,
    }=useQuery({
        queryKey:["getResellerWarranty",searchData],
        queryFn:()=>getResellerWarranty(dynamoDBClient,searchData),
        enabled:false,
        staleTime:0,
        cacheTime:0,
        onSuccess:(data)=>{
            if(data.Count>0){ 
                setResellerData(data.Items)
            }
            setLoading(false)
            setEnableSearch(true)
        },
        onError:(e)=>{
            setError("Error in Reseller Warranty: ",e)
        }
    })

    const {
        status:bsStatus,
        data:bsData,
    }=useQuery({
        queryKey:["getBaseStationWarranty",searchData],
        queryFn:()=>getBaseStationWarranty(dynamoDBClient,searchData),
        enabled:false,
        staleTime:0,
        cacheTime:0,
        onSuccess:(data)=>{
            if(data.Count>0) setBaseStationData(data.Items)
            setLoading(false)
            setEnableSearch(true)
        },
        onError:(e)=>{
            setError("Error in Base Station Warranty: ",e)
        }
    })

    const {
        status:allbsStatus,
        data:allbsData,
    }=useQuery({
        queryKey:["getAllBaseStationWarranty"],
        queryFn:()=>getAllBaseStationWarranty(dynamoDBClient),
        enabled:false,
        staleTime:0,
        cacheTime:0,
        onSuccess:(data)=>{
            if(data.Count>0) setBaseStationData(data.Items)
            setLoading(false)
            setEnableSearch(true)
        },
        onError:(e)=>{
            setError("Error in All Base Station Warranty: ",e)
        }
    })


    const searchToPerform=(data)=>{
        setLoading(true)
        if(searchFilter===1){
            queryClient.fetchQuery(["getResellerWarranty",searchData],()=>getResellerWarranty(dynamoDBClient,searchData))
        }
        if(searchFilter===2){
            queryClient.fetchQuery(["getBaseStationWarranty",searchData],()=>getBaseStationWarranty(dynamoDBClient,searchData))
        }
        if(searchFilter===3){
            queryClient.fetchQuery(["getAllBaseStationWarranty"],()=>getAllBaseStationWarranty(dynamoDBClient))
        }

    }
    const handleKeyPress=(e)=>{
        if(e.key === 'Enter'){
            setEnableSearch(true)
            searchToPerform(searchFilter)
        }
    }


    const performSearch=(type)=>{
        setSearchFilter(type)
        // if(searchData!==""){
        //     searchToPerform(type)
        // }
    }

  return (
    <WarrantyPageStyle>
        <TopBar authorized={true}  />
        <MainBodyStyle>
            <HeadingStyle>Warranty Reports</HeadingStyle>
            <div className='search-bar'>
                <input 
                    className='search-input' 
                    type="text" 
                    placeholder='Search Warranty' 
                    value={searchData} 
                    onChange={e=>{ 
                    setSearchData(e.target.value)
                    setEnableSearch(false)
                    }}
                    onKeyUp={handleKeyPress}
                />
                {enableSearch?
                    <i 
                        className="bi bi-x search-icon" 
                        onClick={()=>{
                            setSearchData(""); 
                            setEnableSearch(false)
                        }}
                    />
                    :
                    <i 
                        className="bi bi-search search-icon" 
                        onClick={()=>{
                            searchToPerform(searchFilter)
                        }}
                    />
                    
                } 
            </div>
            <div>
                <div className='filter-div'>
                    <p className='searchtxt'>Filter :&ensp;</p>
                    <div className="btn-group btn-group-sm btn-div" role="group" aria-label="Basic example">
                        <button 
                        type="button" 
                        className={searchFilter===1?"btn btn-secondary btn-active-div filter-btn":"btn btn-secondary filter-btn"}
                        onClick={()=>performSearch(1)}
                        >Reseller</button>
                        
                        <button 
                        type="button" 
                        className={searchFilter===2?"btn btn-secondary btn-active-div filter-btn":"btn btn-secondary filter-btn"}
                        onClick={()=>performSearch(2)}
                        >Base Station</button>
                        <button 
                        type="button" 
                        className={searchFilter===3?"btn btn-secondary btn-active-div filter-btn":"btn btn-secondary filter-btn"}
                        onClick={()=>performSearch(3)}
                        >All Base Stations</button>
                        <button 
                        type="button" 
                        className={searchFilter===4?"btn btn-secondary btn-active-div filter-btn":"btn btn-secondary filter-btn"}
                        onClick={()=>performSearch(4)}
                        >Beacon</button>
                        <button 
                        type="button" 
                        className={searchFilter===5?"btn btn-secondary btn-active-div filter-btn":"btn btn-secondary filter-btn"}
                        onClick={()=>performSearch(5)}
                        >All Beacons</button>
                    </div>
                </div>
            </div>
            <div className='space-warranty' />
            {
                enableSearch && (
                    <>
                        <HeadingStyle>Report&ensp;<i className="bi bi-clipboard2-data heading-icon" /></HeadingStyle>
                        {searchFilter===1 && <ResellerTable data={resellerData} status={loading} />}
                        {searchFilter===2 && <BaseStationTable data={baseStationData} status={loading} />}
                        {searchFilter===3 && <BaseStationTable data={baseStationData} status={loading} />}
                    </>
                )
            }
            
            
            <ExportDataStyle>
                <div title='All Reseller Reports' className="export-div">
                    <div  
                        className={reportBtnEnable?"download-div2 diable-div":'download-div2'} 
                        // onClick={downloadAllReports}
                    >
                        <i className={"bi bi-cloud-download-fill download-icon2"}></i>
                    </div>
                </div>
            </ExportDataStyle>
        </MainBodyStyle>
        <Footer style="footer" />
    </WarrantyPageStyle>
  )
}

export default Warranty